import GameClientPage from "./GameClientPage";
import "./game-client-page.scss";

export default GameClientPage;
